exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".auth-back {\n  height: 8rem;\n  flex-shrink: 0;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.auth-back>a {\n  font-size: 2rem;\n  text-decoration: none;\n  color: #0d3a52;\n}\n\n.auth-back .auth-back__text {\n  font-size: 2.4rem;\n  padding-left: 1.5rem;\n}\n\n.auth-back--transparent {\n  background: rgba(255,255,255,0.85);\n}\n\n", ""]);

// exports
